<template>
  <div>
    <div v-if="PDMain">
      <!-- 顶部搜索框 -->
      <div class="usertop">
        <!-- 左侧搜索 -->
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="盘点时间：">
              <el-date-picker @change="search" type="month" v-model="formInline.check_date"
                value-format="YYYY-MM" placeholder="请选择盘点时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select v-model="formInline.check_status" @change="search" clearable placeholder="请选择">
                <el-option v-for="item in check_statusList" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <!-- 右侧按钮 -->
        <div>
          <el-button type="success" plain @click="addPD">
            <i class="fa fa-plus"></i>新增盘点单
          </el-button>
        </div>
      </div>
      <!-- 表格内容 -->
      <div>
        <el-table size="small" v-loading="loading" stripe :data="tableData" style="width: 100%" max-height="64vh"
          border>
          <el-table-column prop="check_date" label="盘点日期" width="120" />
          <el-table-column width="80" prop="id" label="盘点单号" />
          <el-table-column width="80" property="operator.name" label="制单人" align="center"/>
          <el-table-column prop="check_status" width="80" label="审核状态" align="center">
            <template #default="scope">
              <el-tooltip class="box-item" effect="dark" :content="scope.row.check_refuse_reason" placement="top">
                <el-link
                  v-if="scope.row.check_refuse_reason!=''">{{scope.row.check_status==1?'待审核':scope.row.check_status==2?'通过':scope.row.check_status==3?'驳回':'-'}}</el-link>
              </el-tooltip>
              <el-link
                v-if="scope.row.check_refuse_reason==''">{{scope.row.check_status==1?'待审核':scope.row.check_status==2?'通过':scope.row.check_status==3?'驳回':'-'}}</el-link>
            </template>
          </el-table-column>
          <el-table-column width="80" property="checkOperator.name" label="审核人" align="center"/>
          <el-table-column width="120" property="check_time" label="审核时间" align="center"/>
          <el-table-column prop="check_status" width="80" label="状态" align="center">
            <template #default="scope">
              <el-tag
                :type="scope.row.status==1?'success':'danger'">{{scope.row.status==1?'正常':scope.row.status==2?'撤销':'-'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100" property="cancelOperator.name" label="撤销人" align="center"/>
          <el-table-column width="100" property="cancel_time" label="撤销时间" align="center"/>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" width="180" align="center">
            <template #default="scope">
              <el-link type="primary" v-if="scope.row.check_status!=2&&scope.row.status==1"
                @click="checkYao(scope.row)">
                审核
              </el-link>
              <el-link type="info" @click="seeInfo(scope.row,1)" v-if="scope.row.check_status!='2'&&scope.row.status!=2">
                修改
              </el-link>
              <el-link type="primary" @click="seeInfo(scope.row,2)">
                详情
              </el-link>
              <el-popconfirm title="撤销后无法撤销，确认撤销吗 ?" v-if="scope.row.status==1&&scope.row.check_status!=2"
                @confirm="stockDelete(scope.row)">
                <template #reference>
                  <el-link type="danger">
                    撤销
                  </el-link>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
            :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalSum" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </div>
    <div v-if="!PDMain">
      <pdInfo ref="pdInfoRef" @refreshDataList="closePDInfo"></pdInfo>
    </div>
    <checkPD ref="checkPDRef" @refreshDataList="tobody"></checkPD>
    <addPD ref="addPDRef" @refreshDataList="PDClick"></addPD>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted, nextTick, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToMonth } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import addPD from './addPD'
  import checkPD from './checkPD'
  import pdInfo from './pdInfo'
  export default {
    components: {
      BaseDialog,
      addPD,
      checkPD,
      pdInfo
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1) {
      let proxy = getCurrentInstance()
      const state = reactive({
        formInline: {
          drug_name: '',
        },
        check_statusList: [{
          name: '全部',
          code: ''
        }, {
          name: '待审核',
          code: '1'
        }, {
          name: '通过',
          code: '2'
        }, {
          name: '驳回',
          code: '3'
        }],
        loading: true,
        pageData: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        pdListDialog: false,//新增盘点单
        isEdit: false,
        pdList: {},//盘点单信息
        tableDataYao: [],
        PDMain: true,
        tableData: [],
        dictList: [],
        title: '',
        pageDataInfo: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        tableDataInfo: [],
        tableDataPD: [],
        ruleFormPd: {},
        drug: '',
        check_order_id: '',
        checkModal: false,
        checkInfo: '',
        ruleFormCheck: {},
        addPDRef: null,
        checkPDRef: null,
        pdInfoRef: null
      })
      onMounted(() => {
        state.formInline.check_date = TimestampToMonth()
      })
      // 获取列表
      const tobody = async () => {
        state.loading = true
        let data = {
          size: state.pageData.pageSize,
          page: state.pageData.currentPage,
          dict_catalog_type: props1.dictCatalogType,
          check_date: state.formInline.check_date,
          check_status: state.formInline.check_status
        }
        let res = await service.post('/api/storeDrugCheck/listOrder', data)
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData = res.data.list
            state.pageData.totalSum = res.data.total
          } else {
            state.tableData = []
            state.pageData.totalSum = 0
          }
        }
        state.loading = false
      }
      // 条数改变时
      const handleSizeChange = (e) => {
        state.pageData.pageSize = e
        tobody()
      }
      // 页数改变时
      const handleCurrentChange = (e) => {
        state.pageData.currentPage = e
        tobody()
      }
      // 查询
      const search = () => {
        tobody()
      }
      const type = () => {
        tobody()
      }
      //新增盘点单
      const addPD = () => {
        // proxy.$refs.addPDRef.pdListDialog = true
        state.addPDRef.initData(props1.dictCatalogType)
      }

      const seeInfo = (row, code) => {
        let type = ''
        if (code == 2) {
          type = false
        } else {
          if (row.check_status == '2' || row.status == 2) {
            type = false
          } else {
            type = true
          }
        }

        PDClick(row.id, type)
      }
      //获取盘点单详情
      const PDClick = (id, type) => {
        console.log(id, type)
        state.isEdit = type
        state.check_order_id = id
        state.PDMain = false
        nextTick(() => {
          state.pdInfoRef.initData(props1.dictCatalogType, state.check_order_id, state.isEdit, state.formInline.check_date)
        })
      }
      const closePDInfo = () => {
        state.PDMain = true
        tobody()
      }
      // 查询
      const searchPD = () => {
        tobodyPD()
      }
      //审核功能
      const checkYao = (row) => {
        state.checkPDRef.initData(props1.dictCatalogType, row, 'pd')
      }

      // 导出
      const exportTable = (row) => {
        let data = {
          dict_type: state.formInline.dict_type,
          drug_name: state.formInline.drug_name,
          check_date: state.formInline.check_date,
          dict_catalog_type: props1.dictCatalogType
        }
        let time = TimestampToTime()
        let title = ''
        if (props1.dictCatalogType == '164000000') {
          title = `科室耗材盘点${time}.xlsx`
        } else {
          title = `科室药品盘点${time}.xlsx`
        }
        downLoadXlsx('/api/stockCheck/check_export', data, title)
      }


      // 删除
      const stockDelete = async (row) => {
        let data = {
          check_order_id: row.id
        }
        let res = await service.post('/api/storeDrugCheck/cancelOrder', data)
        if (res.code == 0) {
          ElMessage({
            message: '撤销成功',
            type: 'success',
          })
          tobody()
        }
      }

      return {
        ...toRefs(state),
        tobody,
        handleSizeChange,
        handleCurrentChange,
        search,
        PDClick,

        type,
        searchPD,
        exportTable,

        stockDelete,
        addPD,
        closePDInfo,
        seeInfo,
        checkYao,
      }
    },
  }
</script>

<style scoped lang="scss">
  .displya_flex {
    display: flex;
    justify-content: space-between;
  }

  .usertop {
    margin-bottom: 8px;
    height: 35px;
    display: flex;
    justify-content: space-between;

    &:deep(.el-alert--warning.is-light) {
      background-color: rgba(49, 102, 174, 0.1);
      color: #3166ae;
    }
  }

  .tabctext {
    height: 20px;
    overflow: hidden;
    cursor: pointer;
    color: rgba(49, 102, 174, 1);
  }
</style>
<style scoped lang="scss">
  .adviceBox {
    height: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 10px;
  }

  .demo-tabs>.el-tabs__content {
    padding: 32px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }

  .display_flex {
    display: flex;
    justify-content: space-between;
  }

  .search-top .w-208 {
    width: 208px;

    .searchcss {
      cursor: pointer;
    }
  }

  .faicon {
    font-size: 19px;
    margin-right: 6px;
    cursor: pointer;
  }

  .title-top {
    align-items: center;
    display: flex;
  }




  .pagination-box {
    &:deep(.el-input__inner) {
      padding-right: 15px !important;
    }
  }

  .w-144 {
    margin-top: 20px;
  }



  .top {
    height: 35px;
    margin: 8px 0;
  }
</style>
